import { driverSupportFirestoreService } from '../services/driverSupportFirestoreService'
import { createUnreadTracker } from '../services/driverSupportUnread'
import { armSupportChatBeep, playSupportAssignBeep, playSupportChatBeep, unreadMessageTotal } from './supportChatBeep'
import { getUserRole } from './userRoleUtils'

const SUPPORT_ROLES = new Set(['support_agent', 'admin', 'manager', 'org_admin', 'owner', 'team_manager'])

/** Listen for new driver unread while any console page is open. */
export function startSupportChatSoundWatch() {
  armSupportChatBeep()
  if (typeof window === 'undefined') return () => {}
  const role = getUserRole()
  if (!SUPPORT_ROLES.has(role)) return () => {}

  let stopped = false
  let primed = false
  let lastSum = 0
  let unsub: (() => void) | null = null
  let primeTimer: ReturnType<typeof setTimeout> | null = null
  const knownIds = new Set<string>()
  const assignedMine = new Map<string, boolean>()

  const tracker = createUnreadTracker((counts) => {
    const sum = unreadMessageTotal(counts)
    if (!primed) {
      lastSum = Math.max(lastSum, sum)
      return
    }
    if (sum > lastSum) playSupportChatBeep()
    lastSum = sum
  })

  const surface = role === 'support_agent' ? 'desk' : 'manage'

  void driverSupportFirestoreService
    .ready()
    .then((session) => {
      if (stopped) return
      unsub = driverSupportFirestoreService.watchTickets((list) => {
        if (!primed) {
          for (const t of list) {
            knownIds.add(t.id)
            assignedMine.set(t.id, driverSupportFirestoreService.isMine(t, session.staffUid))
          }
          if (!primeTimer) {
            primeTimer = setTimeout(() => {
              primed = true
            }, 1500)
          }
        } else {
          for (const t of list) {
            const mine = driverSupportFirestoreService.isMine(t, session.staffUid)
            const wasMine = assignedMine.get(t.id) === true
            const isNew = !knownIds.has(t.id)
            knownIds.add(t.id)
            assignedMine.set(t.id, mine)
            const live = t.status !== 'closed' && t.status !== 'resolved'
            if (mine && !wasMine && live) {
              playSupportAssignBeep()
              continue
            }
            if (isNew && t.status !== 'closed') playSupportChatBeep()
          }
        }
        tracker.update(session.staffUid, list, null, surface)
      })
    })
    .catch(() => {
      /* not signed in as support staff */
    })

  return () => {
    stopped = true
    if (primeTimer) clearTimeout(primeTimer)
    unsub?.()
    tracker.stop()
  }
}
